/**
 * Maps MIME types and file extensions to FontAwesome icon names and colors
 * Returns an object with icon set ('fas', 'far', etc.), icon name, and background color
 */

function getFileExtension(filename) {
  if (!filename) return ''
  const parts = filename.split('.')
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : ''
}

export function getIconForMimeType(mimeType, filename) {
  if (!mimeType) {
    return { iconSet: 'fas', iconName: 'file', color: '#bdb7b7' }
  }

  const normalizedMimeType = mimeType.toLowerCase().trim()
  const extension = getFileExtension(filename)

  // PDFs - Red
  if (normalizedMimeType === 'application/pdf' || extension === 'pdf') {
    return { iconSet: 'fas', iconName: 'file-pdf', color: '#af0505' }
  }

  // Images - Teal
  if (normalizedMimeType.startsWith('image/') || ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'tga'].includes(extension)) {
    return { iconSet: 'fas', iconName: 'file-image', color: '#257f7f' }
  }

  // Word documents - Blue
  if (
    normalizedMimeType === 'application/msword' ||
    normalizedMimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    normalizedMimeType.includes('word') ||
    ['doc', 'docx'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-word', color: '#2b579a' }
  }

  // Excel spreadsheets - Green
  if (
    normalizedMimeType === 'application/vnd.ms-excel' ||
    normalizedMimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    normalizedMimeType.includes('excel') ||
    normalizedMimeType.includes('spreadsheet') ||
    ['xls', 'xlsx'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-excel', color: '#14662d' }
  }

  // PowerPoint presentations - Red-orange
  if (
    normalizedMimeType === 'application/vnd.ms-powerpoint' ||
    normalizedMimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
    normalizedMimeType.includes('powerpoint') ||
    normalizedMimeType.includes('presentation') ||
    ['ppt', 'pptx'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-powerpoint', color: '#a92b1a' }
  }

  // Archives - Yellow/Purple
  if (
    normalizedMimeType === 'application/zip' ||
    normalizedMimeType === 'application/x-zip-compressed' ||
    normalizedMimeType === 'application/x-rar-compressed' ||
    normalizedMimeType === 'application/x-7z-compressed' ||
    normalizedMimeType === 'application/x-tar' ||
    normalizedMimeType === 'application/gzip' ||
    normalizedMimeType.includes('archive') ||
    normalizedMimeType.includes('compressed') ||
    ['zip', 'tgz'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-zipper', color: '#f0d05f' }
  }

  if (extension === 'rar') {
    return { iconSet: 'fas', iconName: 'file-zipper', color: '#bc5eb0' }
  }

  // Audio files - Purple-blue
  if (normalizedMimeType.startsWith('audio/') || ['mp3', 'wav', 'aac', 'aiff', 'mid'].includes(extension)) {
    return { iconSet: 'fas', iconName: 'file-audio', color: '#575dad' }
  }

  // Video files - Purple
  if (normalizedMimeType.startsWith('video/') || ['mp4', 'avi', 'flv', 'qt', 'mpg'].includes(extension)) {
    return { iconSet: 'fas', iconName: 'file-video', color: '#8a3681' }
  }

  // Code files - Gray
  if (
    normalizedMimeType.includes('javascript') ||
    normalizedMimeType.includes('typescript') ||
    normalizedMimeType.includes('python') ||
    normalizedMimeType.includes('java') ||
    normalizedMimeType.includes('html') ||
    normalizedMimeType.includes('css') ||
    normalizedMimeType.includes('php') ||
    normalizedMimeType.includes('ruby') ||
    normalizedMimeType.includes('go') ||
    normalizedMimeType.includes('rust') ||
    normalizedMimeType.includes('c++') ||
    normalizedMimeType.includes('c#') ||
    ['js', 'ts', 'py', 'java', 'html', 'css', 'php', 'rb', 'go', 'rs', 'cpp', 'c', 'h', 'hpp', 'less', 'sass', 'scss', 'sql', 'xml', 'yml'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-code', color: '#bdb7b7' }
  }

  // Text files - Light blue
  if (
    normalizedMimeType.startsWith('text/') ||
    normalizedMimeType === 'application/json' ||
    normalizedMimeType === 'application/xml' ||
    normalizedMimeType === 'text/xml' ||
    ['txt', 'rtf'].includes(extension)
  ) {
    return { iconSet: 'fas', iconName: 'file-lines', color: '#0e85cd' }
  }

  // CSV files - Light blue
  if (
    normalizedMimeType === 'text/csv' ||
    normalizedMimeType === 'application/csv' ||
    extension === 'csv'
  ) {
    return { iconSet: 'fas', iconName: 'file-csv', color: '#0e85cd' }
  }

  // Default file icon - Gray
  return { iconSet: 'fas', iconName: 'file', color: '#bdb7b7' }
}


